import * as m from "react";
import { createElement as Gt, Component as Qt, useLayoutEffect as Nt, useEffect as Ft } from "react";
import * as Zt from "react-dom";
import { findDOMNode as Jt } from "react-dom";
function It(t) {
  var e, o, n = "";
  if (typeof t == "string" || typeof t == "number")
    n += t;
  else if (typeof t == "object")
    if (Array.isArray(t)) {
      var i = t.length;
      for (e = 0; e < i; e++)
        t[e] && (o = It(t[e])) && (n && (n += " "), n += o);
    } else
      for (o in t)
        t[o] && (n && (n += " "), n += o);
  return n;
}
function cn() {
  for (var t, e, o = 0, n = "", i = arguments.length; o < i; o++)
    (t = arguments[o]) && (e = It(t)) && (n && (n += " "), n += e);
  return n;
}
function te(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, dt(t, e);
}
function dt(t, e) {
  return dt = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, dt(t, e);
}
function ee(t, e) {
  if (t == null)
    return {};
  var o = {}, n = Object.keys(t), i, r;
  for (r = 0; r < n.length; r++)
    i = n[r], !(e.indexOf(i) >= 0) && (o[i] = t[i]);
  return o;
}
function Et(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function ne(t, e, o) {
  return t === e ? !0 : t.correspondingElement ? t.correspondingElement.classList.contains(o) : t.classList.contains(o);
}
function oe(t, e, o) {
  if (t === e)
    return !0;
  for (; t.parentNode || t.host; ) {
    if (t.parentNode && ne(t, e, o))
      return !0;
    t = t.parentNode || t.host;
  }
  return t;
}
function ie(t) {
  return document.documentElement.clientWidth <= t.clientX || document.documentElement.clientHeight <= t.clientY;
}
var re = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var e = !1, o = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    }), n = function() {
    };
    return window.addEventListener("testPassiveEventSupport", n, o), window.removeEventListener("testPassiveEventSupport", n, o), e;
  }
};
function se(t) {
  return t === void 0 && (t = 0), function() {
    return ++t;
  };
}
var ce = se(), pt, et = {}, at = {}, le = ["touchstart", "touchmove"], fe = "ignore-react-onclickoutside";
function Ct(t, e) {
  var o = {}, n = le.indexOf(e) !== -1;
  return n && pt && (o.passive = !t.props.preventDefault), o;
}
function ln(t, e) {
  var o, n, i = t.displayName || t.name || "Component";
  return n = o = /* @__PURE__ */ function(r) {
    te(s, r);
    function s(a) {
      var c;
      return c = r.call(this, a) || this, c.__outsideClickHandler = function(f) {
        if (typeof c.__clickOutsideHandlerProp == "function") {
          c.__clickOutsideHandlerProp(f);
          return;
        }
        var u = c.getInstance();
        if (typeof u.props.handleClickOutside == "function") {
          u.props.handleClickOutside(f);
          return;
        }
        if (typeof u.handleClickOutside == "function") {
          u.handleClickOutside(f);
          return;
        }
        throw new Error("WrappedComponent: " + i + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, c.__getComponentNode = function() {
        var f = c.getInstance();
        return e && typeof e.setClickOutsideRef == "function" ? e.setClickOutsideRef()(f) : typeof f.setClickOutsideRef == "function" ? f.setClickOutsideRef() : Jt(f);
      }, c.enableOnClickOutside = function() {
        if (!(typeof document > "u" || at[c._uid])) {
          typeof pt > "u" && (pt = re()), at[c._uid] = !0;
          var f = c.props.eventTypes;
          f.forEach || (f = [f]), et[c._uid] = function(u) {
            if (c.componentNode !== null && !(c.initTimeStamp > u.timeStamp) && (c.props.preventDefault && u.preventDefault(), c.props.stopPropagation && u.stopPropagation(), !(c.props.excludeScrollbar && ie(u)))) {
              var p = u.composed && u.composedPath && u.composedPath().shift() || u.target;
              oe(p, c.componentNode, c.props.outsideClickIgnoreClass) === document && c.__outsideClickHandler(u);
            }
          }, f.forEach(function(u) {
            document.addEventListener(u, et[c._uid], Ct(Et(c), u));
          });
        }
      }, c.disableOnClickOutside = function() {
        delete at[c._uid];
        var f = et[c._uid];
        if (f && typeof document < "u") {
          var u = c.props.eventTypes;
          u.forEach || (u = [u]), u.forEach(function(p) {
            return document.removeEventListener(p, f, Ct(Et(c), p));
          }), delete et[c._uid];
        }
      }, c.getRef = function(f) {
        return c.instanceRef = f;
      }, c._uid = ce(), c.initTimeStamp = performance.now(), c;
    }
    var l = s.prototype;
    return l.getInstance = function() {
      if (t.prototype && !t.prototype.isReactComponent)
        return this;
      var c = this.instanceRef;
      return c.getInstance ? c.getInstance() : c;
    }, l.componentDidMount = function() {
      if (!(typeof document > "u" || !document.createElement)) {
        var c = this.getInstance();
        if (e && typeof e.handleClickOutside == "function" && (this.__clickOutsideHandlerProp = e.handleClickOutside(c), typeof this.__clickOutsideHandlerProp != "function"))
          throw new Error("WrappedComponent: " + i + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside();
      }
    }, l.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, l.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, l.render = function() {
      var c = this.props;
      c.excludeScrollbar;
      var f = ee(c, ["excludeScrollbar"]);
      return t.prototype && t.prototype.isReactComponent ? f.ref = this.getRef : f.wrappedRef = this.getRef, f.disableOnClickOutside = this.disableOnClickOutside, f.enableOnClickOutside = this.enableOnClickOutside, Gt(t, f);
    }, s;
  }(Qt), o.displayName = "OnClickOutside(" + i + ")", o.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: e && e.excludeScrollbar || !1,
    outsideClickIgnoreClass: fe,
    preventDefault: !1,
    stopPropagation: !1
  }, o.getClass = function() {
    return t.getClass ? t.getClass() : t;
  }, n;
}
function G(t) {
  return Ht(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function _(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function V(t) {
  var e;
  return (e = (Ht(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Ht(t) {
  return t instanceof Node || t instanceof _(t).Node;
}
function D(t) {
  return t instanceof Element || t instanceof _(t).Element;
}
function I(t) {
  return t instanceof HTMLElement || t instanceof _(t).HTMLElement;
}
function Pt(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof _(t).ShadowRoot;
}
function J(t) {
  const {
    overflow: e,
    overflowX: o,
    overflowY: n,
    display: i
  } = F(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + o) && !["inline", "contents"].includes(i);
}
function ae(t) {
  return ["table", "td", "th"].includes(G(t));
}
function wt(t) {
  const e = vt(), o = F(t);
  return o.transform !== "none" || o.perspective !== "none" || (o.containerType ? o.containerType !== "normal" : !1) || !e && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !e && (o.filter ? o.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (o.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (o.contain || "").includes(n));
}
function ue(t) {
  let e = B(t);
  for (; I(e) && !Y(e); ) {
    if (wt(e))
      return e;
    e = B(e);
  }
  return null;
}
function vt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Y(t) {
  return ["html", "body", "#document"].includes(G(t));
}
function F(t) {
  return _(t).getComputedStyle(t);
}
function lt(t) {
  return D(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function B(t) {
  if (G(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Pt(t) && t.host || // Fallback.
    V(t)
  );
  return Pt(e) ? e.host : e;
}
function Vt(t) {
  const e = B(t);
  return Y(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : I(e) && J(e) ? e : Vt(e);
}
function Q(t, e, o) {
  var n;
  e === void 0 && (e = []), o === void 0 && (o = !0);
  const i = Vt(t), r = i === ((n = t.ownerDocument) == null ? void 0 : n.body), s = _(i);
  return r ? e.concat(s, s.visualViewport || [], J(i) ? i : [], s.frameElement && o ? Q(s.frameElement) : []) : e.concat(i, Q(i, [], o));
}
const q = Math.min, W = Math.max, it = Math.round, nt = Math.floor, $ = (t) => ({
  x: t,
  y: t
}), de = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, pe = {
  start: "end",
  end: "start"
};
function me(t, e, o) {
  return W(t, q(e, o));
}
function ft(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function K(t) {
  return t.split("-")[0];
}
function tt(t) {
  return t.split("-")[1];
}
function ge(t) {
  return t === "x" ? "y" : "x";
}
function yt(t) {
  return t === "y" ? "height" : "width";
}
function xt(t) {
  return ["top", "bottom"].includes(K(t)) ? "y" : "x";
}
function bt(t) {
  return ge(xt(t));
}
function he(t, e, o) {
  o === void 0 && (o = !1);
  const n = tt(t), i = bt(t), r = yt(i);
  let s = i === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (s = rt(s)), [s, rt(s)];
}
function we(t) {
  const e = rt(t);
  return [mt(t), e, mt(e)];
}
function mt(t) {
  return t.replace(/start|end/g, (e) => pe[e]);
}
function ve(t, e, o) {
  const n = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return o ? e ? i : n : e ? n : i;
    case "left":
    case "right":
      return e ? r : s;
    default:
      return [];
  }
}
function ye(t, e, o, n) {
  const i = tt(t);
  let r = ve(K(t), o === "start", n);
  return i && (r = r.map((s) => s + "-" + i), e && (r = r.concat(r.map(mt)))), r;
}
function rt(t) {
  return t.replace(/left|right|bottom|top/g, (e) => de[e]);
}
function xe(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Bt(t) {
  return typeof t != "number" ? xe(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function st(t) {
  const {
    x: e,
    y: o,
    width: n,
    height: i
  } = t;
  return {
    width: n,
    height: i,
    top: o,
    left: e,
    right: e + n,
    bottom: o + i,
    x: e,
    y: o
  };
}
function St(t, e, o) {
  let {
    reference: n,
    floating: i
  } = t;
  const r = xt(e), s = bt(e), l = yt(s), a = K(e), c = r === "y", f = n.x + n.width / 2 - i.width / 2, u = n.y + n.height / 2 - i.height / 2, p = n[l] / 2 - i[l] / 2;
  let d;
  switch (a) {
    case "top":
      d = {
        x: f,
        y: n.y - i.height
      };
      break;
    case "bottom":
      d = {
        x: f,
        y: n.y + n.height
      };
      break;
    case "right":
      d = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      d = {
        x: n.x - i.width,
        y: u
      };
      break;
    default:
      d = {
        x: n.x,
        y: n.y
      };
  }
  switch (tt(e)) {
    case "start":
      d[s] -= p * (o && c ? -1 : 1);
      break;
    case "end":
      d[s] += p * (o && c ? -1 : 1);
      break;
  }
  return d;
}
const be = async (t, e, o) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: s
  } = o, l = r.filter(Boolean), a = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: f,
    y: u
  } = St(c, n, a), p = n, d = {}, g = 0;
  for (let w = 0; w < l.length; w++) {
    const {
      name: y,
      fn: h
    } = l[w], {
      x,
      y: v,
      data: b,
      reset: R
    } = await h({
      x: f,
      y: u,
      initialPlacement: n,
      placement: p,
      strategy: i,
      middlewareData: d,
      rects: c,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    f = x ?? f, u = v ?? u, d = {
      ...d,
      [y]: {
        ...d[y],
        ...b
      }
    }, R && g <= 50 && (g++, typeof R == "object" && (R.placement && (p = R.placement), R.rects && (c = R.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : R.rects), {
      x: f,
      y: u
    } = St(c, p, a)), w = -1);
  }
  return {
    x: f,
    y: u,
    placement: p,
    strategy: i,
    middlewareData: d
  };
};
async function Re(t, e) {
  var o;
  e === void 0 && (e = {});
  const {
    x: n,
    y: i,
    platform: r,
    rects: s,
    elements: l,
    strategy: a
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: u = "floating",
    altBoundary: p = !1,
    padding: d = 0
  } = ft(e, t), g = Bt(d), y = l[p ? u === "floating" ? "reference" : "floating" : u], h = st(await r.getClippingRect({
    element: (o = await (r.isElement == null ? void 0 : r.isElement(y))) == null || o ? y : y.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: f,
    strategy: a
  })), x = u === "floating" ? {
    x: n,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, v = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(l.floating)), b = await (r.isElement == null ? void 0 : r.isElement(v)) ? await (r.getScale == null ? void 0 : r.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = st(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: x,
    offsetParent: v,
    strategy: a
  }) : x);
  return {
    top: (h.top - R.top + g.top) / b.y,
    bottom: (R.bottom - h.bottom + g.bottom) / b.y,
    left: (h.left - R.left + g.left) / b.x,
    right: (R.right - h.right + g.right) / b.x
  };
}
const Oe = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: o,
      y: n,
      placement: i,
      rects: r,
      platform: s,
      elements: l,
      middlewareData: a
    } = e, {
      element: c,
      padding: f = 0
    } = ft(t, e) || {};
    if (c == null)
      return {};
    const u = Bt(f), p = {
      x: o,
      y: n
    }, d = bt(i), g = yt(d), w = await s.getDimensions(c), y = d === "y", h = y ? "top" : "left", x = y ? "bottom" : "right", v = y ? "clientHeight" : "clientWidth", b = r.reference[g] + r.reference[d] - p[d] - r.floating[g], R = p[d] - r.reference[d], E = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let k = E ? E[v] : 0;
    (!k || !await (s.isElement == null ? void 0 : s.isElement(E))) && (k = l.floating[v] || r.floating[g]);
    const C = b / 2 - R / 2, H = k / 2 - w[g] / 2 - 1, M = q(u[h], H), T = q(u[x], H), P = M, N = k - w[g] - T, A = k / 2 - w[g] / 2 + C, S = me(P, A, N), L = !a.arrow && tt(i) != null && A !== S && r.reference[g] / 2 - (A < P ? M : T) - w[g] / 2 < 0, O = L ? A < P ? A - P : A - N : 0;
    return {
      [d]: p[d] + O,
      data: {
        [d]: S,
        centerOffset: A - S - O,
        ...L && {
          alignmentOffset: O
        }
      },
      reset: L
    };
  }
}), Ee = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var o, n;
      const {
        placement: i,
        middlewareData: r,
        rects: s,
        initialPlacement: l,
        platform: a,
        elements: c
      } = e, {
        mainAxis: f = !0,
        crossAxis: u = !0,
        fallbackPlacements: p,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: w = !0,
        ...y
      } = ft(t, e);
      if ((o = r.arrow) != null && o.alignmentOffset)
        return {};
      const h = K(i), x = K(l) === l, v = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), b = p || (x || !w ? [rt(l)] : we(l));
      !p && g !== "none" && b.push(...ye(l, w, g, v));
      const R = [l, ...b], E = await Re(e, y), k = [];
      let C = ((n = r.flip) == null ? void 0 : n.overflows) || [];
      if (f && k.push(E[h]), u) {
        const P = he(i, s, v);
        k.push(E[P[0]], E[P[1]]);
      }
      if (C = [...C, {
        placement: i,
        overflows: k
      }], !k.every((P) => P <= 0)) {
        var H, M;
        const P = (((H = r.flip) == null ? void 0 : H.index) || 0) + 1, N = R[P];
        if (N)
          return {
            data: {
              index: P,
              overflows: C
            },
            reset: {
              placement: N
            }
          };
        let A = (M = C.filter((S) => S.overflows[0] <= 0).sort((S, L) => S.overflows[1] - L.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!A)
          switch (d) {
            case "bestFit": {
              var T;
              const S = (T = C.map((L) => [L.placement, L.overflows.filter((O) => O > 0).reduce((O, z) => O + z, 0)]).sort((L, O) => L[1] - O[1])[0]) == null ? void 0 : T[0];
              S && (A = S);
              break;
            }
            case "initialPlacement":
              A = l;
              break;
          }
        if (i !== A)
          return {
            reset: {
              placement: A
            }
          };
      }
      return {};
    }
  };
};
async function Ce(t, e) {
  const {
    placement: o,
    platform: n,
    elements: i
  } = t, r = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), s = K(o), l = tt(o), a = xt(o) === "y", c = ["left", "top"].includes(s) ? -1 : 1, f = r && a ? -1 : 1, u = ft(e, t);
  let {
    mainAxis: p,
    crossAxis: d,
    alignmentAxis: g
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return l && typeof g == "number" && (d = l === "end" ? g * -1 : g), a ? {
    x: d * f,
    y: p * c
  } : {
    x: p * c,
    y: d * f
  };
}
const Pe = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var o, n;
      const {
        x: i,
        y: r,
        placement: s,
        middlewareData: l
      } = e, a = await Ce(e, t);
      return s === ((o = l.offset) == null ? void 0 : o.placement) && (n = l.arrow) != null && n.alignmentOffset ? {} : {
        x: i + a.x,
        y: r + a.y,
        data: {
          ...a,
          placement: s
        }
      };
    }
  };
};
function $t(t) {
  const e = F(t);
  let o = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const i = I(t), r = i ? t.offsetWidth : o, s = i ? t.offsetHeight : n, l = it(o) !== r || it(n) !== s;
  return l && (o = r, n = s), {
    width: o,
    height: n,
    $: l
  };
}
function Rt(t) {
  return D(t) ? t : t.contextElement;
}
function X(t) {
  const e = Rt(t);
  if (!I(e))
    return $(1);
  const o = e.getBoundingClientRect(), {
    width: n,
    height: i,
    $: r
  } = $t(e);
  let s = (r ? it(o.width) : o.width) / n, l = (r ? it(o.height) : o.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const Se = /* @__PURE__ */ $(0);
function Wt(t) {
  const e = _(t);
  return !vt() || !e.visualViewport ? Se : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function ke(t, e, o) {
  return e === void 0 && (e = !1), !o || e && o !== _(t) ? !1 : e;
}
function j(t, e, o, n) {
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  const i = t.getBoundingClientRect(), r = Rt(t);
  let s = $(1);
  e && (n ? D(n) && (s = X(n)) : s = X(t));
  const l = ke(r, o, n) ? Wt(r) : $(0);
  let a = (i.left + l.x) / s.x, c = (i.top + l.y) / s.y, f = i.width / s.x, u = i.height / s.y;
  if (r) {
    const p = _(r), d = n && D(n) ? _(n) : n;
    let g = p, w = g.frameElement;
    for (; w && n && d !== g; ) {
      const y = X(w), h = w.getBoundingClientRect(), x = F(w), v = h.left + (w.clientLeft + parseFloat(x.paddingLeft)) * y.x, b = h.top + (w.clientTop + parseFloat(x.paddingTop)) * y.y;
      a *= y.x, c *= y.y, f *= y.x, u *= y.y, a += v, c += b, g = _(w), w = g.frameElement;
    }
  }
  return st({
    width: f,
    height: u,
    x: a,
    y: c
  });
}
const Ae = [":popover-open", ":modal"];
function Ot(t) {
  return Ae.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function De(t) {
  let {
    elements: e,
    rect: o,
    offsetParent: n,
    strategy: i
  } = t;
  const r = i === "fixed", s = V(n), l = e ? Ot(e.floating) : !1;
  if (n === s || l && r)
    return o;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = $(1);
  const f = $(0), u = I(n);
  if ((u || !u && !r) && ((G(n) !== "body" || J(s)) && (a = lt(n)), I(n))) {
    const p = j(n);
    c = X(n), f.x = p.x + n.clientLeft, f.y = p.y + n.clientTop;
  }
  return {
    width: o.width * c.x,
    height: o.height * c.y,
    x: o.x * c.x - a.scrollLeft * c.x + f.x,
    y: o.y * c.y - a.scrollTop * c.y + f.y
  };
}
function Le(t) {
  return Array.from(t.getClientRects());
}
function jt(t) {
  return j(V(t)).left + lt(t).scrollLeft;
}
function _e(t) {
  const e = V(t), o = lt(t), n = t.ownerDocument.body, i = W(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), r = W(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -o.scrollLeft + jt(t);
  const l = -o.scrollTop;
  return F(n).direction === "rtl" && (s += W(e.clientWidth, n.clientWidth) - i), {
    width: i,
    height: r,
    x: s,
    y: l
  };
}
function Te(t, e) {
  const o = _(t), n = V(t), i = o.visualViewport;
  let r = n.clientWidth, s = n.clientHeight, l = 0, a = 0;
  if (i) {
    r = i.width, s = i.height;
    const c = vt();
    (!c || c && e === "fixed") && (l = i.offsetLeft, a = i.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: l,
    y: a
  };
}
function Me(t, e) {
  const o = j(t, !0, e === "fixed"), n = o.top + t.clientTop, i = o.left + t.clientLeft, r = I(t) ? X(t) : $(1), s = t.clientWidth * r.x, l = t.clientHeight * r.y, a = i * r.x, c = n * r.y;
  return {
    width: s,
    height: l,
    x: a,
    y: c
  };
}
function kt(t, e, o) {
  let n;
  if (e === "viewport")
    n = Te(t, o);
  else if (e === "document")
    n = _e(V(t));
  else if (D(e))
    n = Me(e, o);
  else {
    const i = Wt(t);
    n = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return st(n);
}
function zt(t, e) {
  const o = B(t);
  return o === e || !D(o) || Y(o) ? !1 : F(o).position === "fixed" || zt(o, e);
}
function Ne(t, e) {
  const o = e.get(t);
  if (o)
    return o;
  let n = Q(t, [], !1).filter((l) => D(l) && G(l) !== "body"), i = null;
  const r = F(t).position === "fixed";
  let s = r ? B(t) : t;
  for (; D(s) && !Y(s); ) {
    const l = F(s), a = wt(s);
    !a && l.position === "fixed" && (i = null), (r ? !a && !i : !a && l.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || J(s) && !a && zt(t, s)) ? n = n.filter((f) => f !== s) : i = l, s = B(s);
  }
  return e.set(t, n), n;
}
function Fe(t) {
  let {
    element: e,
    boundary: o,
    rootBoundary: n,
    strategy: i
  } = t;
  const s = [...o === "clippingAncestors" ? Ot(e) ? [] : Ne(e, this._c) : [].concat(o), n], l = s[0], a = s.reduce((c, f) => {
    const u = kt(e, f, i);
    return c.top = W(u.top, c.top), c.right = q(u.right, c.right), c.bottom = q(u.bottom, c.bottom), c.left = W(u.left, c.left), c;
  }, kt(e, l, i));
  return {
    width: a.right - a.left,
    height: a.bottom - a.top,
    x: a.left,
    y: a.top
  };
}
function Ie(t) {
  const {
    width: e,
    height: o
  } = $t(t);
  return {
    width: e,
    height: o
  };
}
function He(t, e, o) {
  const n = I(e), i = V(e), r = o === "fixed", s = j(t, !0, r, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = $(0);
  if (n || !n && !r)
    if ((G(e) !== "body" || J(i)) && (l = lt(e)), n) {
      const u = j(e, !0, r, e);
      a.x = u.x + e.clientLeft, a.y = u.y + e.clientTop;
    } else
      i && (a.x = jt(i));
  const c = s.left + l.scrollLeft - a.x, f = s.top + l.scrollTop - a.y;
  return {
    x: c,
    y: f,
    width: s.width,
    height: s.height
  };
}
function ut(t) {
  return F(t).position === "static";
}
function At(t, e) {
  return !I(t) || F(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function Ut(t, e) {
  const o = _(t);
  if (Ot(t))
    return o;
  if (!I(t)) {
    let i = B(t);
    for (; i && !Y(i); ) {
      if (D(i) && !ut(i))
        return i;
      i = B(i);
    }
    return o;
  }
  let n = At(t, e);
  for (; n && ae(n) && ut(n); )
    n = At(n, e);
  return n && Y(n) && ut(n) && !wt(n) ? o : n || ue(t) || o;
}
const Ve = async function(t) {
  const e = this.getOffsetParent || Ut, o = this.getDimensions, n = await o(t.floating);
  return {
    reference: He(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Be(t) {
  return F(t).direction === "rtl";
}
const Xt = {
  convertOffsetParentRelativeRectToViewportRelativeRect: De,
  getDocumentElement: V,
  getClippingRect: Fe,
  getOffsetParent: Ut,
  getElementRects: Ve,
  getClientRects: Le,
  getDimensions: Ie,
  getScale: X,
  isElement: D,
  isRTL: Be
};
function $e(t, e) {
  let o = null, n;
  const i = V(t);
  function r() {
    var l;
    clearTimeout(n), (l = o) == null || l.disconnect(), o = null;
  }
  function s(l, a) {
    l === void 0 && (l = !1), a === void 0 && (a = 1), r();
    const {
      left: c,
      top: f,
      width: u,
      height: p
    } = t.getBoundingClientRect();
    if (l || e(), !u || !p)
      return;
    const d = nt(f), g = nt(i.clientWidth - (c + u)), w = nt(i.clientHeight - (f + p)), y = nt(c), x = {
      rootMargin: -d + "px " + -g + "px " + -w + "px " + -y + "px",
      threshold: W(0, q(1, a)) || 1
    };
    let v = !0;
    function b(R) {
      const E = R[0].intersectionRatio;
      if (E !== a) {
        if (!v)
          return s();
        E ? s(!1, E) : n = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      v = !1;
    }
    try {
      o = new IntersectionObserver(b, {
        ...x,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(b, x);
    }
    o.observe(t);
  }
  return s(!0), r;
}
function fn(t, e, o, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = n, c = Rt(t), f = i || r ? [...c ? Q(c) : [], ...Q(e)] : [];
  f.forEach((h) => {
    i && h.addEventListener("scroll", o, {
      passive: !0
    }), r && h.addEventListener("resize", o);
  });
  const u = c && l ? $e(c, o) : null;
  let p = -1, d = null;
  s && (d = new ResizeObserver((h) => {
    let [x] = h;
    x && x.target === c && d && (d.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var v;
      (v = d) == null || v.observe(e);
    })), o();
  }), c && !a && d.observe(c), d.observe(e));
  let g, w = a ? j(t) : null;
  a && y();
  function y() {
    const h = j(t);
    w && (h.x !== w.x || h.y !== w.y || h.width !== w.width || h.height !== w.height) && o(), w = h, g = requestAnimationFrame(y);
  }
  return o(), () => {
    var h;
    f.forEach((x) => {
      i && x.removeEventListener("scroll", o), r && x.removeEventListener("resize", o);
    }), u == null || u(), (h = d) == null || h.disconnect(), d = null, a && cancelAnimationFrame(g);
  };
}
const an = Pe, un = Ee, Dt = Oe, We = (t, e, o) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: Xt,
    ...o
  }, r = {
    ...i.platform,
    _c: n
  };
  return be(t, e, {
    ...i,
    platform: r
  });
}, dn = (t) => {
  function e(o) {
    return {}.hasOwnProperty.call(o, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(o) {
      const {
        element: n,
        padding: i
      } = typeof t == "function" ? t(o) : t;
      return n && e(n) ? n.current != null ? Dt({
        element: n.current,
        padding: i
      }).fn(o) : {} : n ? Dt({
        element: n,
        padding: i
      }).fn(o) : {};
    }
  };
};
var ot = typeof document < "u" ? Nt : Ft;
function ct(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let o, n, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (o = t.length, o !== e.length)
        return !1;
      for (n = o; n-- !== 0; )
        if (!ct(t[n], e[n]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), o = i.length, o !== Object.keys(e).length)
      return !1;
    for (n = o; n-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[n]))
        return !1;
    for (n = o; n-- !== 0; ) {
      const r = i[n];
      if (!(r === "_owner" && t.$$typeof) && !ct(t[r], e[r]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Yt(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Lt(t, e) {
  const o = Yt(t);
  return Math.round(e * o) / o;
}
function _t(t) {
  const e = m.useRef(t);
  return ot(() => {
    e.current = t;
  }), e;
}
function je(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: o = "absolute",
    middleware: n = [],
    platform: i,
    elements: {
      reference: r,
      floating: s
    } = {},
    transform: l = !0,
    whileElementsMounted: a,
    open: c
  } = t, [f, u] = m.useState({
    x: 0,
    y: 0,
    strategy: o,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [p, d] = m.useState(n);
  ct(p, n) || d(n);
  const [g, w] = m.useState(null), [y, h] = m.useState(null), x = m.useCallback((O) => {
    O !== E.current && (E.current = O, w(O));
  }, []), v = m.useCallback((O) => {
    O !== k.current && (k.current = O, h(O));
  }, []), b = r || g, R = s || y, E = m.useRef(null), k = m.useRef(null), C = m.useRef(f), H = a != null, M = _t(a), T = _t(i), P = m.useCallback(() => {
    if (!E.current || !k.current)
      return;
    const O = {
      placement: e,
      strategy: o,
      middleware: p
    };
    T.current && (O.platform = T.current), We(E.current, k.current, O).then((z) => {
      const U = {
        ...z,
        isPositioned: !0
      };
      N.current && !ct(C.current, U) && (C.current = U, Zt.flushSync(() => {
        u(U);
      }));
    });
  }, [p, e, o, T]);
  ot(() => {
    c === !1 && C.current.isPositioned && (C.current.isPositioned = !1, u((O) => ({
      ...O,
      isPositioned: !1
    })));
  }, [c]);
  const N = m.useRef(!1);
  ot(() => (N.current = !0, () => {
    N.current = !1;
  }), []), ot(() => {
    if (b && (E.current = b), R && (k.current = R), b && R) {
      if (M.current)
        return M.current(b, R, P);
      P();
    }
  }, [b, R, P, M, H]);
  const A = m.useMemo(() => ({
    reference: E,
    floating: k,
    setReference: x,
    setFloating: v
  }), [x, v]), S = m.useMemo(() => ({
    reference: b,
    floating: R
  }), [b, R]), L = m.useMemo(() => {
    const O = {
      position: o,
      left: 0,
      top: 0
    };
    if (!S.floating)
      return O;
    const z = Lt(S.floating, f.x), U = Lt(S.floating, f.y);
    return l ? {
      ...O,
      transform: "translate(" + z + "px, " + U + "px)",
      ...Yt(S.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: o,
      left: z,
      top: U
    };
  }, [o, l, S.floating, f.x, f.y]);
  return m.useMemo(() => ({
    ...f,
    update: P,
    refs: A,
    elements: S,
    floatingStyles: L
  }), [f, P, A, S, L]);
}
const qt = {
  ...m
}, ze = qt.useInsertionEffect, Ue = ze || ((t) => t());
function Xe(t) {
  const e = m.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Ue(() => {
    e.current = t;
  }), m.useCallback(function() {
    for (var o = arguments.length, n = new Array(o), i = 0; i < o; i++)
      n[i] = arguments[i];
    return e.current == null ? void 0 : e.current(...n);
  }, []);
}
var gt = typeof document < "u" ? Nt : Ft;
function ht() {
  return ht = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
    }
    return t;
  }, ht.apply(this, arguments);
}
let Tt = !1, Ye = 0;
const Mt = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + Ye++
);
function qe() {
  const [t, e] = m.useState(() => Tt ? Mt() : void 0);
  return gt(() => {
    t == null && e(Mt());
  }, []), m.useEffect(() => {
    Tt = !0;
  }, []), t;
}
const Ke = qt.useId, Kt = Ke || qe;
let Z;
process.env.NODE_ENV !== "production" && (Z = /* @__PURE__ */ new Set());
function Ge() {
  for (var t, e = arguments.length, o = new Array(e), n = 0; n < e; n++)
    o[n] = arguments[n];
  const i = "Floating UI: " + o.join(" ");
  if (!((t = Z) != null && t.has(i))) {
    var r;
    (r = Z) == null || r.add(i), console.warn(i);
  }
}
function Qe() {
  for (var t, e = arguments.length, o = new Array(e), n = 0; n < e; n++)
    o[n] = arguments[n];
  const i = "Floating UI: " + o.join(" ");
  if (!((t = Z) != null && t.has(i))) {
    var r;
    (r = Z) == null || r.add(i), console.error(i);
  }
}
const pn = /* @__PURE__ */ m.forwardRef(function(e, o) {
  const {
    context: {
      placement: n,
      elements: {
        floating: i
      },
      middlewareData: {
        arrow: r
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: a = 0,
    strokeWidth: c = 0,
    staticOffset: f,
    stroke: u,
    d: p,
    style: {
      transform: d,
      ...g
    } = {},
    ...w
  } = e;
  process.env.NODE_ENV !== "production" && (o || Ge("The `ref` prop is required for `FloatingArrow`."));
  const y = Kt();
  if (!i)
    return null;
  const h = c * 2, x = h / 2, v = s / 2 * (a / -8 + 1), b = l / 2 * a / 4, [R, E] = n.split("-"), k = Xt.isRTL(i), C = !!p, H = R === "top" || R === "bottom", M = f && E === "end" ? "bottom" : "top";
  let T = f && E === "end" ? "right" : "left";
  f && k && (T = E === "end" ? "left" : "right");
  const P = (r == null ? void 0 : r.x) != null ? f || r.x : "", N = (r == null ? void 0 : r.y) != null ? f || r.y : "", A = p || "M0,0" + (" H" + s) + (" L" + (s - v) + "," + (l - b)) + (" Q" + s / 2 + "," + l + " " + v + "," + (l - b)) + " Z", S = {
    top: C ? "rotate(180deg)" : "",
    left: C ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: C ? "" : "rotate(180deg)",
    right: C ? "rotate(-90deg)" : "rotate(90deg)"
  }[R];
  return /* @__PURE__ */ m.createElement("svg", ht({}, w, {
    "aria-hidden": !0,
    ref: o,
    width: C ? s : s + h,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [T]: P,
      [M]: N,
      [R]: H || C ? "100%" : "calc(100% - " + h / 2 + "px)",
      transform: "" + S + (d ?? ""),
      ...g
    }
  }), h > 0 && /* @__PURE__ */ m.createElement("path", {
    clipPath: "url(#" + y + ")",
    fill: "none",
    stroke: u,
    strokeWidth: h + (p ? 0 : 1),
    d: A
  }), /* @__PURE__ */ m.createElement("path", {
    stroke: h && !p ? w.fill : "none",
    d: A
  }), /* @__PURE__ */ m.createElement("clipPath", {
    id: y
  }, /* @__PURE__ */ m.createElement("rect", {
    x: -x,
    y: x * (C ? -1 : 1),
    width: s + h,
    height: s
  })));
});
function Ze() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, o) {
      var n;
      (n = t.get(e)) == null || n.forEach((i) => i(o));
    },
    on(e, o) {
      t.set(e, [...t.get(e) || [], o]);
    },
    off(e, o) {
      var n;
      t.set(e, ((n = t.get(e)) == null ? void 0 : n.filter((i) => i !== o)) || []);
    }
  };
}
const Je = /* @__PURE__ */ m.createContext(null), tn = /* @__PURE__ */ m.createContext(null), en = () => {
  var t;
  return ((t = m.useContext(Je)) == null ? void 0 : t.id) || null;
}, nn = () => m.useContext(tn);
function on(t) {
  const {
    open: e = !1,
    onOpenChange: o,
    elements: n
  } = t, i = Kt(), r = m.useRef({}), [s] = m.useState(() => Ze()), l = en() != null;
  if (process.env.NODE_ENV !== "production") {
    const d = n.reference;
    d && !D(d) && Qe("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [a, c] = m.useState(n.reference), f = Xe((d, g, w) => {
    r.current.openEvent = d ? g : void 0, s.emit("openchange", {
      open: d,
      event: g,
      reason: w,
      nested: l
    }), o == null || o(d, g, w);
  }), u = m.useMemo(() => ({
    setPositionReference: c
  }), []), p = m.useMemo(() => ({
    reference: a || n.reference || null,
    floating: n.floating || null,
    domReference: n.reference
  }), [a, n.reference, n.floating]);
  return m.useMemo(() => ({
    dataRef: r,
    open: e,
    onOpenChange: f,
    elements: p,
    events: s,
    floatingId: i,
    refs: u
  }), [e, f, p, s, i, u]);
}
function mn(t) {
  t === void 0 && (t = {});
  const {
    nodeId: e
  } = t, o = on({
    ...t,
    elements: {
      reference: null,
      floating: null,
      ...t.elements
    }
  }), n = t.rootContext || o, i = n.elements, [r, s] = m.useState(null), [l, a] = m.useState(null), f = (i == null ? void 0 : i.reference) || r, u = m.useRef(null), p = nn();
  gt(() => {
    f && (u.current = f);
  }, [f]);
  const d = je({
    ...t,
    elements: {
      ...i,
      ...l && {
        reference: l
      }
    }
  }), g = m.useCallback((v) => {
    const b = D(v) ? {
      getBoundingClientRect: () => v.getBoundingClientRect(),
      contextElement: v
    } : v;
    a(b), d.refs.setReference(b);
  }, [d.refs]), w = m.useCallback((v) => {
    (D(v) || v === null) && (u.current = v, s(v)), (D(d.refs.reference.current) || d.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    v !== null && !D(v)) && d.refs.setReference(v);
  }, [d.refs]), y = m.useMemo(() => ({
    ...d.refs,
    setReference: w,
    setPositionReference: g,
    domReference: u
  }), [d.refs, w, g]), h = m.useMemo(() => ({
    ...d.elements,
    domReference: f
  }), [d.elements, f]), x = m.useMemo(() => ({
    ...d,
    ...n,
    refs: y,
    elements: h,
    nodeId: e
  }), [d, y, h, e, n]);
  return gt(() => {
    n.dataRef.current.floatingContext = x;
    const v = p == null ? void 0 : p.nodesRef.current.find((b) => b.id === e);
    v && (v.context = x);
  }), m.useMemo(() => ({
    ...d,
    context: x,
    refs: y,
    elements: h
  }), [d, y, h, x]);
}
function gn(t, e, o) {
  return t.slice(e, o);
}
export {
  pn as F,
  fn as a,
  an as b,
  cn as c,
  dn as d,
  un as f,
  ln as o,
  gn as s,
  mn as u
};
